import React, { ChangeEvent, Component } from "react";

import { IDeviceConfigurationDocument } from "@formant/core/model/IDeviceConfigurationDocument";
import { IRosTopic } from "@formant/core/model/IRosTopic";
import { rosTypeBool } from "@formant/core/model/rosTypes";
import { InputElement } from "@formant/ui/component/common/Field";
import { TextField } from "@formant/ui/component/common/TextField";

import { SelectField } from "../common/SelectField";
import {
    EditTeleopStreamPopup,
    IEditTeleopStreamPopupProps,
} from "./EditTeleopStreamPopup";

export interface ITeleopButtonConfigurationProps extends IEditTeleopStreamPopupProps {
    streamName?: string;
    document: IDeviceConfigurationDocument;
    topics: IRosTopic[];
    onChange: (document: IDeviceConfigurationDocument) => void;
}

export class TeleopButtonConfiguration extends Component<ITeleopButtonConfigurationProps> {
    public render() {
        const { streamName, document, topics, visible, onClose } = this.props;
        const stream = document.teleop?.rosStreams?.find(
            _ => _.topicName === streamName,
        );

        const boolTopics = topics
            .filter(_ => _.type === rosTypeBool)
            .map(_ => _.name);

        return (
            <EditTeleopStreamPopup
                visible={visible}
                onClose={onClose}
                title={`Configuration for: ${streamName}`}
            >
                <p>Add an optional status topic</p>
                <TextField
                    value={stream?.statusTopic || ""}
                    onChange={this.onChangeTopic}
                    label="Status topic name"
                    placeholder="Status topic name - eg. /boolean/topic"
                    list={boolTopics}
                    autoFocus={true}
                    small={true}
                />

                <p>Add an optional button label</p>
                <TextField
                    value={stream?.buttonLabel || ""}
                    onChange={this.onChangeLabel}
                    label="Button label"
                    placeholder="Label for your button"
                    list={boolTopics}
                    autoFocus={false}
                    small={true}
                />
                <p>Choose a button color</p>
                <SelectField
                    value={stream?.buttonColor || "default"}
                    small={true}
                    label="Button Color"
                    onChange={this.onChangeColor}
                >
                    <option value="default"> Black</option>
                    <option value="primary">Blue</option>
                    <option value="secondary">White</option>
                    <option value="tertiary">Steel</option>
                    <option value="destructive">Red</option>
                </SelectField>
            </EditTeleopStreamPopup>
        );
    }

    private onChangeTopic = (event: ChangeEvent<InputElement>) => {
        const { streamName, document, onChange } = this.props;

        const existing = document.teleop?.rosStreams?.find(
            _ =>
                _.topicName === streamName &&
                _.topicType === "std_msgs/Bool" &&
                _.mode === "command",
        );
        if (!existing) {
            return;
        }

        existing.statusTopic = event.target.value;

        onChange({ ...document });
    };

    private onChangeLabel = (event: ChangeEvent<InputElement>) => {
        const { streamName, document, onChange } = this.props;

        const existing = document.teleop?.rosStreams?.find(
            _ =>
                _.topicName === streamName &&
                _.topicType === "std_msgs/Bool" &&
                _.mode === "command",
        );

        if (!existing) {
            return;
        }

        existing.buttonLabel = event.target.value;
        onChange({ ...document });
    };

    private onChangeColor = (event: ChangeEvent<InputElement>) => {
        const { streamName, document, onChange } = this.props;

        const existing = document.teleop?.rosStreams?.find(
            _ =>
                _.topicName === streamName &&
                _.topicType === "std_msgs/Bool" &&
                _.mode === "command",
        );

        if (!existing) {
            return;
        }

        existing.buttonColor = event.target.value;
        onChange({ ...document });
    };
}
